<template>
  <i-select
    :value="value"
    :filterable="true"
    :clearable="true"
    :loading="is_loading"
    :multiple="multiple"
    v-on="$listeners"
  >
    <template v-if="!multiple && country.length > 0">
      <i-option v-for="item in country" :key="item.id" :value="item.iso" :label="item.label" />
    </template>
    <template v-if="multiple && country.length > 0">
      <i-option v-for="item in country" :key="item.id" :value="item.code" :label="item.label" />
    </template>
  </i-select>
</template>

<script>
  import { CountryService } from '@core/services/CountryService';
  import axios from 'axios';
  import faker from 'faker/locale/en';

  export default {
    props: {
      value: {
        type: [String, Number],
        default: null
      },
      multiple: {
        type: Boolean,
        default: false
      },

      only_user_data: {
        type: Boolean,
        default: false
      }
    },

    data() {
      return {
        is_loading: true,
        codes: [],
        items: [],
        country: []
      };
    },
    mounted() {
      this.is_loading = true;
      axios
        .all([CountryService.getSelect(), CountryService.getCountriesCodes()])
        .then(
          axios.spread((isoCodes, codes) => {
            this.country = this.mergeCodesAndIso(codes, isoCodes);
          })
        )
        .finally(() => (this.is_loading = false));
    },
    methods: {
      mergeCodesAndIso: function (codes, isoCodes) {
        const result = [];
        for (let i = 0; i < isoCodes.length; i++) {
          debugger;
          const language = isoCodes[i];
          const codeList = codes.filter((code) => code.country === language.country);
          const codeLabels = codeList.map((code) => `+${code.code}`);
          const label = `${language.country} ${codeLabels.join(', ')}`;
          result.push({ id: faker.random.uuid(), iso: language.iso, label });
        }
        return result;
      }
    }
  };
</script>
